<template>
  <div class="black-place-order-success">
    <main class="success-content">
      <div class="success-icon" aria-hidden="true">
        <span></span>
      </div>

      <div class="success-copy">
        <p>点菜成功</p>
        <h1>美味制作中</h1>
        <span>后厨正在为您精心准备，请耐心等待</span>
      </div>

      <button type="button" class="detail-button" @click="handleToDetail">
        查看消费明细
      </button>
    </main>
  </div>
</template>

<script>
export default {
  name: "BlackPlaceOrderSuccess",
  data() {
    return {
      previousPageChromeTheme: null,
    };
  },
  created() {
    this.applyPageChromeTheme();
  },
  beforeDestroy() {
    this.restorePageChromeTheme();
  },
  methods: {
    /**
     * 进入黑色点单记录页面查看消费明细。
     * 使用 replace 避免用户从记录页返回时再次进入提交成功页面，
     * 行为与 PlaceOrderSuccess.vue 的原有跳转方式保持一致。
     *
     * @returns {void}
     */
    handleToDetail() {
      this.$router.replace({ name: "BlackRecordConsume" });
    },
    /**
     * 获取指定 meta 标签；页面不存在该标签时自动创建。
     * 集中处理可以避免主题初始化逻辑重复操作 document.head。
     *
     * @param {string} attribute 用于查询 meta 的属性名。
     * @param {string} value 用于查询 meta 的属性值。
     * @returns {HTMLMetaElement} 已存在或新创建的 meta 标签。
     */
    getOrCreateMeta(attribute, value) {
      let meta = document.head.querySelector(
        `meta[${attribute}="${value}"]`
      );
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, value);
        document.head.appendChild(meta);
      }
      return meta;
    },
    /**
     * 应用与 BlackMicropoint 一致的深色页面主题。
     * 同时设置浏览器主题色、色彩模式及 html/body 背景，
     * 避免页面加载、回弹和底部安全区出现白色。
     *
     * @returns {void}
     */
    applyPageChromeTheme() {
      const themeColorMeta = this.getOrCreateMeta("name", "theme-color");
      const statusBarMeta = this.getOrCreateMeta(
        "name",
        "apple-mobile-web-app-status-bar-style"
      );
      const colorSchemeMeta = this.getOrCreateMeta("name", "color-scheme");

      this.previousPageChromeTheme = {
        themeColor: themeColorMeta.getAttribute("content") || "",
        statusBar: statusBarMeta.getAttribute("content") || "",
        colorScheme: colorSchemeMeta.getAttribute("content") || "",
        htmlBackground: document.documentElement.style.backgroundColor,
        bodyBackground: document.body.style.backgroundColor,
      };

      themeColorMeta.setAttribute("content", "#171717");
      statusBarMeta.setAttribute("content", "black-translucent");
      colorSchemeMeta.setAttribute("content", "dark");
      document.documentElement.style.backgroundColor = "#171717";
      document.body.style.backgroundColor = "#171717";
    },
    /**
     * 离开页面时恢复进入前的浏览器主题，防止影响项目其他浅色页面。
     *
     * @returns {void}
     */
    restorePageChromeTheme() {
      if (!this.previousPageChromeTheme) return;
      this.getOrCreateMeta("name", "theme-color").setAttribute(
        "content",
        this.previousPageChromeTheme.themeColor
      );
      this.getOrCreateMeta(
        "name",
        "apple-mobile-web-app-status-bar-style"
      ).setAttribute("content", this.previousPageChromeTheme.statusBar);
      this.getOrCreateMeta("name", "color-scheme").setAttribute(
        "content",
        this.previousPageChromeTheme.colorScheme
      );
      document.documentElement.style.backgroundColor =
        this.previousPageChromeTheme.htmlBackground;
      document.body.style.backgroundColor =
        this.previousPageChromeTheme.bodyBackground;
    },
  },
};
</script>

<style scoped lang="scss">
.black-place-order-success {
  width: 100%;
  min-height: 100vh;
  padding: 0 32px calc(42px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #f7f4ee;
  background-color: #202120;
  background-image: url("~@/assets/black-micropoint/bg.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.success-content {
  display: flex;
  min-height: calc(100vh - 42px - env(safe-area-inset-bottom));
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
}

.success-icon {
  position: relative;
  display: flex;
  width: 270px;
  height: 270px;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(241, 200, 95, 0.72);
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(240, 199, 93, 0.24) 0,
      rgba(82, 68, 36, 0.56) 56%,
      rgba(30, 30, 30, 0.72) 100%
    );
  box-shadow:
    0 0 0 18px rgba(239, 195, 87, 0.06),
    0 0 44px rgba(239, 195, 87, 0.2);
  transform: translateY(-50px);

  &::before,
  &::after {
    position: absolute;
    border: 1px solid rgba(240, 199, 93, 0.2);
    border-radius: 50%;
    content: "";
  }

  &::before {
    width: 224px;
    height: 224px;
  }

  &::after {
    width: 184px;
    height: 184px;
  }

  span {
    z-index: 1;
    width: 88px;
    height: 48px;
    border-bottom: 10px solid #f1ca63;
    border-left: 10px solid #f1ca63;
    transform: translateY(-12px) rotate(-45deg);
  }
}

.success-copy {
  margin-top: 23px;
  text-align: center;

  p {
    margin: 0;
    color: white;
    font-size: 32px;
    line-height: 42px;
  }

  h1 {
    margin: 8px 0 0;
    color: #f1ca63;
    font-size: 40px;
    font-weight: 500;
    line-height: 62px;
    letter-spacing: 2px;
  }

  span {
    display: block;
    margin-top: 23px;
    color: white;
    font-size: 28px;
    line-height: 30px;
  }
}

.detail-button {
  position: fixed;
  z-index: 10;
  width: 90%;
  right: 5%;
  bottom: calc(40px + env(safe-area-inset-bottom));
  left: 5%;
  height: 68px;
  border: 0;
  border-radius: 6px;
  color: #2c230e;
  background: linear-gradient(90deg, #d7aa42, #ffe78d);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
  font-size: 25px;
  font-weight: 600;
}
</style>
